import { SVGProps } from "react";

export default function CaCloseIcon(props: SVGProps<never>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9048 14.2711C15.842 14.1194 15.7499 13.9816 15.6338 13.8655L9.76741 8L15.6338 2.13452C15.8683 1.90003 16 1.582 16 1.25038C16 0.918755 15.8683 0.600717 15.6338 0.366226C15.3993 0.131735 15.0812 0 14.7496 0C14.418 0 14.0999 0.131762 13.8654 0.366253L8 6.23259L2.13452 0.366226C1.90003 0.131735 1.582 0 1.25038 0C0.918755 0 0.600717 0.131735 0.366226 0.366226C0.131735 0.600717 0 0.918755 0 1.25038C0 1.582 0.131762 1.90006 0.366253 2.13455L6.23259 8L0.366226 13.8655C0.131735 14.1 0 14.418 0 14.7496C0 15.0812 0.131735 15.3993 0.366226 15.6338C0.600717 15.8683 0.918755 16 1.25038 16C1.582 16 1.90006 15.8682 2.13455 15.6337L8 9.76741L13.8655 15.6338C13.9816 15.7499 14.1194 15.842 14.2711 15.9048C14.4228 15.9677 14.5854 16 14.7496 16C14.9138 16 15.0764 15.9677 15.2281 15.9048C15.3798 15.842 15.5177 15.7499 15.6338 15.6338C15.7499 15.5177 15.842 15.3798 15.9048 15.2281C15.9677 15.0764 16 14.9138 16 14.7496C16 14.5854 15.9677 14.4228 15.9048 14.2711Z"
        fill="#2D224C"
      />
    </svg>
  );
}
